import { Component, OnInit, ViewChild } from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";
import { Observable, of, Subject } from "rxjs";
import { catchError, delay, distinctUntilChanged, map, switchMap, tap } from "rxjs/operators";

import { Usuario } from "@shared/Entities/Usuario/usuario.entity";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

@Component({
  selector: "app-permisos",
  templateUrl: "./permisos.component.html",
  styleUrls: ["./permisos.component.scss"],
})
export class PermisosComponent implements OnInit {
  public showResume: boolean = false;
  public coincidenciaUsuarios$: Observable<Usuario[]>;
  public usuariosInput$: Subject<string> = new Subject<string>();
  public loadingUsuario = false;
  public currentInput: string;
  public invalidUsuarioCharacter: boolean;
  public usuario: Usuario;
  public usuarioDestino: Usuario;
  public coincidenciaUsuariosDestino$: Observable<Usuario[]>;
  public usuariosInputDestino$: Subject<string> = new Subject<string>();
  public loadingUsuarioDestino = false;
  public currentInputDestino: string;
  public invalidUsuarioCharacterDestino: boolean;
  public usuariosDestinos = new Array<Usuario>();
  public reiniciarPermisos: boolean = false;
  public copiarIntermediarioUnit: boolean = false;
  public minTermLength: number = 3;
  @ViewChild("usuariosDestinosSelection", { static: false }) public ngSelectComponent: NgSelectComponent;
  @ViewChild("usuarioFuentePermisos", { static: false }) public ngSelect: NgSelectComponent;
  constructor(private userRepository: UsuariosRepository) {}

  public ngOnInit(): void {
    this.getPeople();
    this.getPeopleDestination();
  }

  public copiarPermisos(): void {
    const objUsuarios = {
      emailOrigen: this.usuario.email,
      emailsDestino: this.usuariosDestinos.map((usuario) => usuario.email),
      borrarPermisosExistentes: this.reiniciarPermisos ? true : false,
      copiarIntermediarioUnit: this.copiarIntermediarioUnit,
    };
    this.userRepository.copiarPermisosDeUsuarios(objUsuarios).subscribe(() => {
      this.showResume = true;
    });
  }

  public copiarOtroUsuario(): void {
    this.usuariosDestinos = [];
    this.reiniciarPermisos = false;
    this.showResume = false;
    setTimeout(() => {
      this.ngSelect.handleClearClick();
    });
  }

  public addToUsuariosDestino(usuario: Usuario): void {
    if (usuario && this.usuariosDestinos.findIndex((usuarioInArray) => usuarioInArray.id === usuario.id) < 0) {
      this.usuariosDestinos.push(usuario);
      this.ngSelectComponent.handleClearClick();
    }
  }

  public borrarUsuario(usuarioABorrar: Usuario): void {
    this.usuariosDestinos = this.usuariosDestinos.filter((usuario) => usuario.id !== usuarioABorrar.id);
  }

  private getPeople() {
    this.coincidenciaUsuarios$ = this.usuariosInput$.pipe(
      distinctUntilChanged(),
      tap((term) => {
        this.currentInput = term;
      }),
      delay(1000),
      switchMap((term) => {
        if (term && term.length >= this.minTermLength && this.currentInput === term) {
          this.invalidUsuarioCharacter = false;
          this.loadingUsuario = true;
          return this.userRepository.getUserToAssignPermissions(term).pipe(
            map((afiliados) => {
              this.loadingUsuario = false;
              return afiliados;
            }),
            catchError(() => {
              this.loadingUsuario = false;
              return of([]);
            })
          );
        }
        return of([]);
      })
    );
  }

  private getPeopleDestination() {
    this.coincidenciaUsuariosDestino$ = this.usuariosInputDestino$.pipe(
      distinctUntilChanged(),
      tap((term) => {
        this.currentInput = term;
      }),
      delay(1000),
      switchMap((term) => {
        if (term && term.length >= this.minTermLength && this.currentInput === term) {
          this.invalidUsuarioCharacterDestino = false;
          this.loadingUsuarioDestino = true;
          return this.userRepository.getUserToAssignPermissions(term).pipe(
            map((afiliados) => {
              this.loadingUsuarioDestino = false;
              return afiliados;
            }),
            catchError(() => {
              this.loadingUsuarioDestino = false;
              return of([]);
            })
          );
        }
        return of([]);
      })
    );
  }
}
